import type { PaletteMode } from '@mui/material';

import { LocalStorageKeys } from 'Consts/localStorageKeys';
import type { CourseListViewMode } from 'Courses/pages/courses-list/CoursesListView.consts';

const setLocalStorageItem = (key: string, value: string): void => {
  try {
    localStorage.setItem(key, value);
  } catch (error) {
    console.warn(`Failed to save ${key} to localStorage:`, error);
  }
};

const getLocalStorageItem = (key: string): string | null => {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    console.warn(`Failed to read ${key} from localStorage:`, error);
    return null;
  }
};

const removeLocalStorageItem = (key: string): void => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.warn(`Failed to remove ${key} from localStorage:`, error);
  }
};

export const saveThemeToLocalStorage = (theme: PaletteMode): void => {
  setLocalStorageItem(LocalStorageKeys.theme, theme);
};

export const getThemeFromLocalStorage = (): PaletteMode | null =>
  getLocalStorageItem(LocalStorageKeys.theme) as PaletteMode | null;

export const saveLanguageToLocalStorage = (language: string): void => {
  setLocalStorageItem(LocalStorageKeys.language, language);
};

export const getLanguageFromLocalStorage = (): string | null =>
  getLocalStorageItem(LocalStorageKeys.language);

export const saveTimezoneToLocalStorage = (timezone: string): void => {
  setLocalStorageItem(LocalStorageKeys.timezone, timezone);
};

export const getTimezoneFromLocalStorage = (): string | null =>
  getLocalStorageItem(LocalStorageKeys.timezone);

export const saveCoursesViewModeToLocalStorage = (viewMode: CourseListViewMode): void => {
  setLocalStorageItem(LocalStorageKeys.coursesViewMode, viewMode);
};

export const getCoursesViewModeFromLocalStorage = (): CourseListViewMode | null =>
  getLocalStorageItem(LocalStorageKeys.coursesViewMode) as CourseListViewMode | null;

export const clearAllPreferencesFromLocalStorage = (): void => {
  removeLocalStorageItem(LocalStorageKeys.theme);
  removeLocalStorageItem(LocalStorageKeys.language);
  removeLocalStorageItem(LocalStorageKeys.timezone);
  removeLocalStorageItem(LocalStorageKeys.coursesViewMode);
};
